<script>
import { mapState, mapActions } from 'vuex';
/*  */
import OauthOperators from '@/components/OauthOperators';
import InputBlock from '@/components/InputBlock';
import Button from '@/components/Button';
/*  */
import { setToken } from '@/scripts/axios';
import { getProfile, getToken } from '@/scripts/api/account';
import {
  processGoogleReCaptcha,
  checkEmailValid,
  setAsyncInputError,
  emitClick,
  checkValidAndEmitClick,
} from '@/scripts/methods';
import { clearAll } from '@/scripts/utils/store-dependent';
import { email } from '@/scripts/watch';
import { wsConnection } from '@/scripts/modules/ws';

export default {
  name: 'Login',
  data() {
    return {
      profile: null,
      email: '',
      password: '',
      /*  */
      emailError: null,
      validFlagId: null,
    };
  },
  components: {
    Button,
    OauthOperators,
    InputBlock,
  },
  watch: {
    email,
    user(user) {
      if (user) this.$router.push('/dashboard');
    },
  },
  computed: {
    ...mapState(['user']),

    isFormValid() {
      const { email, password } = this;
      const result = !!(this.checkEmailValid(email) && password);

      return result;
    },
  },
  created() {},
  mounted() {},
  methods: {
    ...mapActions({
      setUser: 'setUser',
    }),
    onRecaptchaVerified(reCaptcha, id) {
      const { email, password } = this;

      window.grecaptcha.reset(id);

      getToken({ email, password, reCaptcha })
        .then(token => {
          setToken(token);
          wsConnection.setToken(token);
          wsConnection.connect('users');

          return getProfile();
        })
        .then(user => {
          this.setUser(user);

          this.$router.push('/dashboard');
        })
        .catch(clearAll);
    },
    processGoogleReCaptcha,
    checkEmailValid,
    setAsyncInputError,
    emitClick,
    checkValidAndEmitClick,
  },
};
</script>

<template>
  <div class="Login">
    <!--  -->
    <div class="Login__content">
      <div class="Login__top">
        <div class="Login__arrow" @click="$router.push('/')">
          <img :src="require('@/assets/svg/arrow-left.svg')" />
        </div>
        <div class="Login__title">Login</div>
        <div class="Login__signup">
          <Button to="/sign-up" class="link-input">Sign Up</Button>
        </div>
      </div>
      <div class="Login__middle">
        <!-- > -->
        <OauthOperators @ready="processGoogleReCaptcha" />
        <!-- < -->
        <div class="Login__separate">
          <span>or</span>
        </div>
        <div class="Login__form">
          <div class="form">
            <div class="form__row">
              <InputBlock
                :error="emailError"
                :forceValue="email"
                @input="val => (email = val)"
                @enter="checkValidAndEmitClick('recaptcha-login')"
                tabindex="1"
                type="text"
                class="error-relative"
              >
                <template #label>
                  Email
                </template>
              </InputBlock>
            </div>
            <div class="form__row">
              <InputBlock
                :forceValue="password"
                @input="val => (password = val)"
                @enter="checkValidAndEmitClick('recaptcha-login')"
                tabindex="2"
                type="password"
              >
                <template #label>
                  Password
                </template>
                <template #linkTop>
                  <Button class="link-input" to="/reset"
                    >Forgot Password?</Button
                  >
                </template>
              </InputBlock>
            </div>
            <div class="form__row form__row--btn">
              <!-- main action -->
              <Button
                ref="recaptcha-login"
                :disabled="!isFormValid"
                class="btn"
                tabindex="3"
              >
                Login
              </Button>
            </div>
          </div>
        </div>
        <div v-if="profile">{{ profile.username }}</div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '@/styles/variables.scss';
.Login {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 100vh;
  height: 100%;
  padding: 80px 20px 20px;

  &__content {
    max-width: 570px;
    width: 100%;
  }

  &__title {
    font-family: Poppins-Light;
    font-size: 36px;
    line-height: 51px;
    color: #ffffff;
  }

  &__arrow {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 20px;
    cursor: pointer;
    transition: all 0.2;

    img {
      width: 16px;
      height: 14px;
      display: flex;
    }

    &:hover {
      opacity: 0.7;
    }
  }

  &__top {
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    width: 100%;
  }

  &__signup {
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-left: 10px;
  }

  &__separate {
    position: relative;
    display: flex;
    justify-content: center;
    font-family: Poppins-Regular;
    font-size: 14px;
    line-height: 20px;
    color: rgba(255, 255, 255, 0.2);
    width: 100%;
    padding: 50px 0;
    text-transform: uppercase;

    span {
      padding: 0 26px;
      position: relative;
    }

    &:after {
      content: '';
      position: absolute;
      width: calc(50% - 36px);
      height: 1px;
      background: rgba(255, 255, 255, 0.2);
      top: 50%;
      left: 0;
      transform: translateY(-50%);
    }
    &:before {
      content: '';
      position: absolute;
      width: calc(50% - 36px);
      height: 1px;
      background: rgba(255, 255, 255, 0.2);
      top: 50%;
      right: 0;
      transform: translateY(-50%);
    }
  }
}

.form {
  width: 100%;

  &__row {
    width: 100%;

    & + & {
      margin-top: 30px;
    }

    & + &--btn {
      margin-top: 50px;
    }

    &--btn {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      width: 100%;
    }
  }

  &__item {
    display: flex;
    align-items: center;
  }
}

.btn {
  height: 44px;
  border-radius: 17px;
  background-color: #4e7cff;
  min-width: 170px;
  outline: none;
  padding: 5px 10px;
  font-family: Poppins-Medium;
  font-size: 14px;
  line-height: 20px;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  border: 0;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    opacity: 0.5;
  }

  &:disabled {
    opacity: 0.5;
    pointer-events: none;
  }
}

@media (max-width: $mobile) {
  .Login {
    justify-content: flex-start;
    padding: 20px 15px;

    &__title {
      font-size: 21px;
      line-height: 29px;
    }

    &__top {
      margin-bottom: 50px;
    }

    &__arrow {
      img {
        width: 19px;
        height: 16px;
      }
    }

    &__separate {
      padding: 40px 0;
    }
  }

  .form {
    &__row {
      & + &--btn {
        margin-top: 40px;
      }

      &--btn {
        justify-content: center;
      }
    }
  }

  .btn {
    width: 100%;
    max-width: 290px;
  }
}
</style>
